import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import type { DriverOperation } from "@/utils/operations";

interface Props {
  operations: DriverOperation[];
  selected: number[];
  onToggle: (operationId: number) => void;
  /** En edición: la operación del grupo, fija. */
  locked?: { name: string };
}

/** Solo se renderiza cuando los SVCs del chofer abarcan más de una operación. */
export const OperationSelector = ({ operations, selected, onToggle, locked }: Props) => (
  <div className="mb-6">
    <Label className="block mb-3 text-lg font-medium">
      {locked ? "Operación" : "Seleccione las operaciones"}
    </Label>
    <div className="grid grid-cols-1 gap-2">
      {locked ? (
        <div className="border-2 border-primary bg-primary-soft rounded-lg p-3">
          <span className="font-medium" translate="no">{locked.name}</span>
        </div>
      ) : (
        operations.map((op) => (
          <label
            key={op.id}
            className={`border-2 rounded-lg p-3 transition-colors cursor-pointer block ${
              selected.includes(op.id)
                ? "border-primary bg-primary-soft"
                : "border-gray-200 hover:border-gray-300"
            }`}
          >
            <div className="flex items-center space-x-3">
              <Checkbox
                checked={selected.includes(op.id)}
                onCheckedChange={() => onToggle(op.id)}
                className="h-4 w-4"
              />
              <span className="font-medium" translate="no">{op.name}</span>
            </div>
          </label>
        ))
      )}
    </div>
  </div>
);
